import React, { createElement } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { Provider } from 'mobx-react';

import SideLayout from '@view/side-layout/';
import PrivateRoute from '@view/authRouter';

import menuState from './store/menu-state';
import appState from './store/app-state';

import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import { inject, observer } from 'mobx-react';

import zhCN from 'antd/lib/locale-provider/zh_CN';
import { LocaleProvider } from 'antd';
import { history } from './store/app-state';

import Loadable from 'react-loadable';

import { Spin } from 'antd';
import './App.css';
import './App.less';
import CommonUtil from '@utils/common';

const dynamicWrapper = component => {
	return Loadable({
		loader: () => {
			return component().then(raw => {
				const Component = raw.default || raw;
				return props =>
					createElement(Component, {
						...props,
					});
			});
		},
		loading: () => {
			return <Spin size='large' className='global-spin' />;
		},
	});
};

const Login = dynamicWrapper(() => import('@view/login/'));
const ForbiddenPage = dynamicWrapper(() => import('@view/Exception/403'));
const NotFoundPage = dynamicWrapper(() => import('@view/Exception/404'));
const ErrorPage = dynamicWrapper(() => import('@view/Exception/500'));
const ErrorPageOut = dynamicWrapper(() => import('@view/Exception/500500'));

const PassWord = dynamicWrapper(() => import('@view/password'));

//MJK管理员主页
const MyAdminUser = dynamicWrapper(() => import('@view/myadmin/user/'));
const MyAdminUserAdd = dynamicWrapper(() => import('@view/myadmin/user/add-form'));
const MyAdminProject = dynamicWrapper(() => import('@view/myadmin/project/'));
const MyAdminProjectForm = dynamicWrapper(() => import('@view/myadmin/project/form'));
// const MyAdminProjectEdit = dynamicWrapper(() => import("@view/myadmin/project/edit"));
const MyAdminPermission = dynamicWrapper(() => import('@view/myadmin/permission/'));
const MyAdminPermissionAdd = dynamicWrapper(() => import('@view/myadmin/permission/add-form'));
const MyAdminPermissionNew = dynamicWrapper(() => import('@view/myadmin/permission-new/'));
const MyAdminPermissionNewAdd = dynamicWrapper(
	() => import('@view/myadmin/permission-new/add-form')
);
const MyAdminPermissionPro = dynamicWrapper(() => import('@view/myadmin/permission-pro/'));
const Privacy = dynamicWrapper(() => import('@view/myadmin/privacy'));
const PrivacyForm = dynamicWrapper(() => import('@view/myadmin/privacy/form'));
const PrivacyDetail = dynamicWrapper(() => import('@view/myadmin/privacy/detail'));
const adminFactory = dynamicWrapper(() => import('@view/myadmin/factory/'));
const adminFactoryForm = dynamicWrapper(() => import('@view/myadmin/factory/form'));
const HelpList = dynamicWrapper(() => import('@view/myadmin/help/'));
const HelpAdd = dynamicWrapper(() => import('@view/myadmin/help/add-form'));
const HelpDetail = dynamicWrapper(() => import('@view/myadmin/help/detail'));
const BlankList = dynamicWrapper(() => import('@view/myadmin/blank-list/'));
const BlankListAdd = dynamicWrapper(() => import('@view/myadmin/blank-list/add-form'));
const BlankListEdit = dynamicWrapper(() => import('@view/myadmin/blank-list/edit-form'));
const LoginLog = dynamicWrapper(() => import('@view/myadmin/loginlog/'));
const LoginLogDetail = dynamicWrapper(() => import('@view/myadmin/loginlog/detail'));
const PrivacyLog = dynamicWrapper(() => import('@view/myadmin/privacylog/'));
const PrivacyLogDetail = dynamicWrapper(() => import('@view/myadmin/privacylog/detail'));
const OperationLog = dynamicWrapper(() => import('@view/myadmin/operation/'));
const OperationLogDetail = dynamicWrapper(() => import('@view/myadmin/operation/detail'));
const ExportCenterTask = dynamicWrapper(() => import('@view/export-center-task'));
const Version = dynamicWrapper(() => import('@view/myadmin/version/'));
const MaterialType = dynamicWrapper(() => import('@view/myadmin/material/type'));
const MaterialManage = dynamicWrapper(() => import('@view/myadmin/material/manage'));
const MaterialManageForm = dynamicWrapper(() => import('@view/myadmin/material/manage/form'));
const NfcTag = dynamicWrapper(() => import('@view/nfc-tag'));

//项目管理员主页
const Home = dynamicWrapper(() => import('@view/home/'));

// 个人中心
const Info = dynamicWrapper(() => import('@view/account/info'));
const ChangePhone = dynamicWrapper(() => import('@view/account/changePhone'));
const ChangePwd = dynamicWrapper(() => import('@view/account/changePwd'));
const JoinProject = dynamicWrapper(() => import('@view/account/joinProject'));

//系统通知
const Notice = dynamicWrapper(() => import('@view/myadmin/notice'));
const NoticeAdd = dynamicWrapper(() => import('@view/myadmin/notice/add-form'));
const NoticeDetail = dynamicWrapper(() => import('@view/myadmin/notice/detail'));
const NoticeEdit = dynamicWrapper(() => import('@view/myadmin/notice/edit'));

const Selfeqpt = dynamicWrapper(() => import('@view/selfeqpt'));
const SelfeqptForm = dynamicWrapper(() => import('@view/selfeqpt/form'));
const MealVersion = dynamicWrapper(() => import('@view/meal'));
const AccessControlPrintTemplate = dynamicWrapper(() => import('@view/access_control/template'));
const PrivacyLogNew = dynamicWrapper(() => import('@view/privacy_log'));
const PrivacyLogNewDetail = dynamicWrapper(() => import('@view/privacy_log/detail'));

/**
 * 推送模板
 */
const PushTemplateList = dynamicWrapper(() => import('@view/push_template'));
const PushTemplateHandle = dynamicWrapper(() => import('@view/push_template/handle'));

let _util = new CommonUtil();

@inject('menuState')
@observer
class Ppa extends React.Component {
	componentDidMount() {
		_util.removeSession('currentPage');
		_util.removeSession('scrollTop');
		_util.removeSession('pageSize');
	}

	render() {
		const { language } = this.props.menuState;

		return (
			<LocaleProvider locale={language === 'en' ? null : language === 'zh' ? zhCN : null}>
				<Provider menuState={menuState} appState={appState}>
					<Router history={history}>
						<Switch>
							<Route path='/login' component={Login} />
							<Route path='/error' component={ErrorPageOut} />

							<Route
								path='/'
								render={() => (
									<SideLayout>
										<Switch>
											{/* 项目主页 */}
											<PrivateRoute exact component={Home} path='/' />
											<PrivateRoute
												exact
												path='/403'
												component={ForbiddenPage}
											/>
											<PrivateRoute exact path='/500' component={ErrorPage} />
											<PrivateRoute
												exact
												path='/404'
												component={NotFoundPage}
											/>
											<PrivateRoute
												exact
												component={PassWord}
												path='/password'
											/>

											{/* MJK管理员主页 */}
											<PrivateRoute
												exact
												component={MyAdminUser}
												path='/super/user'
											/>
											<PrivateRoute
												exact
												component={MyAdminUserAdd}
												path='/super/user/add/:id?'
											/>
											<PrivateRoute
												exact
												component={MyAdminProject}
												path='/super/project'
											/>
											<PrivateRoute
												exact
												component={MyAdminProjectForm}
												path='/super/project/add'
											/>
											<PrivateRoute
												exact
												component={MyAdminProjectForm}
												path='/super/project/edit/:id'
											/>
											{/* <PrivateRoute exact component={MyAdminProjectEdit} path='/super/project/edit' /> */}
											<PrivateRoute
												exact
												component={MyAdminPermission}
												path='/super/permission'
											/>
											<PrivateRoute
												exact
												component={MyAdminPermissionAdd}
												path='/super/permission/add/:id?'
											/>
											<PrivateRoute
												exact
												component={MyAdminPermissionNew}
												path='/super/permission-new'
											/>
											<PrivateRoute
												exact
												component={MyAdminPermissionNewAdd}
												path='/super/permission-new/add/:id?'
											/>
											<PrivateRoute
												exact
												component={MyAdminPermissionPro}
												path='/super/permission-pro'
											/>
											<PrivateRoute
												exact
												component={Privacy}
												path='/super/privacy'
											/>
											<PrivateRoute
												exact
												component={PrivacyForm}
												path='/super/privacy/add'
											/>
											<PrivateRoute
												exact
												component={PrivacyForm}
												path='/super/privacy/edit/:id'
											/>
											<PrivateRoute
												exact
												component={PrivacyDetail}
												path='/super/privacy/detail'
											/>

											<PrivateRoute
												exact
												component={adminFactory}
												path='/super/factory'
											/>
											<PrivateRoute
												exact
												component={adminFactoryForm}
												path='/super/factory/add'
											/>
											<PrivateRoute
												exact
												component={adminFactoryForm}
												path='/super/factory/edit/:id'
											/>

											<PrivateRoute
												exact
												component={HelpList}
												path='/super/help'
											/>
											<PrivateRoute
												exact
												component={HelpAdd}
												path='/super/help/add'
											/>
											<PrivateRoute
												exact
												component={HelpDetail}
												path='/super/help/detail'
											/>
											<PrivateRoute
												exact
												component={BlankList}
												path='/super/blank'
											/>
											<PrivateRoute
												exact
												component={BlankListAdd}
												path='/super/blank/add/:id?'
											/>
											<PrivateRoute
												exact
												component={BlankListEdit}
												path='/super/blank/edit'
											/>
											<PrivateRoute
												exact
												component={LoginLog}
												path='/super/loginlog'
											/>
											<PrivateRoute
												exact
												component={LoginLogDetail}
												path='/super/loginlog/detail'
											/>
											<PrivateRoute
												exact
												component={PrivacyLog}
												path='/super/privacylog'
											/>
											<PrivateRoute
												exact
												component={PrivacyLogDetail}
												path='/super/privacylog/detail'
											/>
											<PrivateRoute
												exact
												component={OperationLog}
												path='/super/operation'
											/>
											<PrivateRoute
												exact
												component={OperationLogDetail}
												path='/super/operation/detail'
											/>
											<PrivateRoute
												exact
												component={ExportCenterTask}
												path='/super/export-center-task'
											/>
											<PrivateRoute
												exact
												component={NfcTag}
												path='/super/nfc-tag'
											/>
											<PrivateRoute
												exact
												component={Version}
												path='/super/version'
											/>
											<PrivateRoute
												exact
												component={MaterialType}
												path='/material/type'
											/>
											<PrivateRoute
												exact
												component={MaterialManage}
												path='/material/manage'
											/>
											<PrivateRoute
												exact
												component={MaterialManageForm}
												path='/material/manage/add'
											/>

											<PrivateRoute
												exact
												component={MaterialManageForm}
												path='/material/manage/edit/:id?'
											/>

											<PrivateRoute
												exact
												component={Info}
												path='/account/info'
											/>
											<PrivateRoute
												exact
												component={ChangePhone}
												path='/account/changePhone'
											/>
											<PrivateRoute
												exact
												component={ChangePwd}
												path='/account/changePwd'
											/>
											<PrivateRoute
												exact
												component={JoinProject}
												path='/account/joinProject'
											/>
											<PrivateRoute
												exact
												component={Notice}
												path='/myadmin/notice'
											/>
											<PrivateRoute
												exact
												component={NoticeAdd}
												path='/myadmin/notice/add'
											/>
											<PrivateRoute
												exact
												component={NoticeDetail}
												path='/myadmin/notice/detail/:id'
											/>
											<PrivateRoute
												exact
												component={NoticeEdit}
												path='/myadmin/notice/edit/:id'
											/>
											<PrivateRoute
												exact
												component={Selfeqpt}
												path='/super/selfeqpt'
											/>
											<PrivateRoute
												exact
												component={SelfeqptForm}
												path='/super/selfeqpt/add'
											/>
											<PrivateRoute
												exact
												component={SelfeqptForm}
												path='/super/selfeqpt/edit/:id'
											/>
											<PrivateRoute
												exact
												component={MealVersion}
												path='/super/meal'
											/>
											<PrivateRoute
												exact
												component={AccessControlPrintTemplate}
												path='/super/access_control/print/template'
											/>
											<PrivateRoute
												exact
												component={PrivacyLogNew}
												path='/super/privacy_log'
											/>
											<PrivateRoute
												exact
												component={PrivacyLogNewDetail}
												path='/super/privacy_log/detail/:id'
											/>
											<PrivateRoute
												exact
												component={PushTemplateList}
												path='/super/push_template'
											/>
											<PrivateRoute
												exact
												component={PushTemplateHandle}
												path='/super/push_template/add'
											/>
											<PrivateRoute
												exact
												component={PushTemplateHandle}
												path='/super/push_template/edit/:id'
											/>
											<Redirect from='*' to='/404' />
										</Switch>
									</SideLayout>
								)}
							/>
						</Switch>
					</Router>
				</Provider>
			</LocaleProvider>
		);
	}
}

export default DragDropContext(HTML5Backend)(Ppa);
